import React from 'react';
import {
  DefaultTheme,
  ThemeProvider as StyledComponentThemeProvider
} from 'styled-components';
import { IChildrenProps } from '../../models/utilTypes';
import THEME from '../../styles/colors';

interface IThemeProviderProps extends IChildrenProps {
  theme?: DefaultTheme;
}

const ThemeProvider: React.FC<IThemeProviderProps> = ({
  children,
  theme = { fonts: {}, colors: {} }
}) => (
  <StyledComponentThemeProvider
    theme={{
      colors: {
        ...THEME,
        ...theme.colors
      },
      table: {
        alternateRowBackgroundColor: THEME.surface.tertiary,
        borderColor: THEME.general.border
      }
    }}
  >
    {children}
  </StyledComponentThemeProvider>
);

export default ThemeProvider;
